export const assetTypes = {
    FETCH_REQUEST: "ASSET_OLD_FETCH_REQUEST",
    FETCH_SUCCESS: "ASSET_OLD_FETCH_SUCCESS",
    UPDATE_FILTERS: "ASSET_OLD_UPDATE_FILTERS",
    FETCH_FAILURE: "ASSET_OLD_FETCH_FAILURE",
    DOWNLOAD_REQUEST: "ASSET_OLD_DOWNLOAD_REQUEST",
    DOWNLOAD_SUCCESS: "ASSET_OLD_DOWNLOAD_SUCCESS",
    DOWNLOAD_FAILURE: "DOWNLOAD_FAILURE"
};

export const fetchRequest = (filter) => ({
    type: assetTypes.FETCH_REQUEST,
    payload: filter
});

export const fetchSuccess = (resp) => ({
    type: assetTypes.FETCH_SUCCESS,
    payload: resp
});

export const updateFilters = (resp) => ({
    type: assetTypes.UPDATE_FILTERS,
    payload: resp
});

export const devicesCountSuccess = (resp) => ({
    type: assetTypes.DEVICE_COUNT_SUCCESS,
    payload: resp
});

export const fetchFailure = (resp) => ({
    type: assetTypes.FETCH_FAILURE,
    payload: resp
});

export const downloadRequest = (req, filterList) => ({
    type: assetTypes.DOWNLOAD_REQUEST,
    payload: req,
    filter: filterList
});

export const downloadSuccess = (resp) => ({
    type: assetTypes.DOWNLOAD_SUCCESS,
    payload: resp
});

export const downloadFailure = (error) => ({
    type: assetTypes.DOWNLOAD_FAILURE,
    payload: error
});